(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sbc-share-sheet"] && !Shopify.designMode) return;
  try {
    (() => {
    const sheet = document.getElementById('sbc-share-sheet');
    if (!sheet) return;
    const input = sheet.querySelector('#sbc-share-url');
    const status = sheet.querySelector('[data-share-status]');
    const nativeButton = sheet.querySelector('[data-share-native]');
    let activeData;
    let sourceButton;
    let sharing = false;
    const reveal = () => document.querySelectorAll('[data-sbc-share][hidden]').forEach(button => { button.hidden = false; });
    reveal();
    new MutationObserver(reveal).observe(document.body, { childList: true, subtree: true });
    function payload(button) {
      let source = button;
      if (button.dataset.shareKind === 'page') {
        if (sheet.dataset.pageType === 'cart') {
          source = document.querySelector('main [data-share-kind="cart"]');
          if (!source) return null;
        } else if (sheet.dataset.pageType === 'product') {
          source = document.querySelector('main [data-share-kind="product"]') || button;
        }
      }
      const url = new URL(source.dataset.shareUrl, window.location.origin);
      if (source.dataset.shareKind !== 'cart') {
        url.search = '';
        url.hash = '';
        const isProduct = source.dataset.shareKind === 'product' || sheet.dataset.pageType === 'product';
        if (isProduct) {
          const current = new URL(window.location.href);
          const sameProduct = current.pathname.replace(/\/$/, '') === url.pathname.replace(/\/$/, '');
          const variant = (sameProduct && current.searchParams.get('variant')) || source.dataset.shareVariant;
          if (/^\d+$/.test(variant || '')) url.searchParams.set('variant', variant);
        }
      }
      return { title: source.dataset.shareTitle || sheet.dataset.pageTitle, url: url.href };
    }
    function openSheet(data) {
      activeData = data;
      status.textContent = '';
      sheet.querySelector('[data-share-caption]').textContent = data.title;
      input.value = data.url;
      sheet.querySelector('[data-share-whatsapp]').href = 'https://wa.me/?text=' + encodeURIComponent(data.title + '\n' + data.url);
      sheet.querySelector('[data-share-email]').href = 'mailto:?subject=' + encodeURIComponent(data.title) + '&body=' + encodeURIComponent(data.url);
      nativeButton.hidden = typeof navigator.share !== 'function';
      if (!sheet.open) sheet.showModal();
      document.documentElement.classList.add('sbc-share-open');
    }
    async function nativeShare(data) {
      if (sharing) return;
      if (typeof navigator.share !== 'function') { openSheet(data); return; }
      sharing = true;
      try {
        await navigator.share(data);
      } catch (error) {
        if (error.name !== 'AbortError') openSheet(data);
      } finally {
        sharing = false;
      }
    }
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-sbc-share]');
      if (!button) return;
      event.preventDefault();
      sourceButton = button;
      const data = payload(button);
      if (!data) {
        openSheet({ title: sheet.dataset.pageTitle, url: sheet.dataset.pageUrl });
        status.textContent = sheet.dataset.empty;
        sheet.querySelector('.sbc-share-sheet__options').hidden = true;
        input.hidden = true;
        sheet.querySelector('.sbc-share-sheet__label').hidden = true;
        return;
      }
      sheet.querySelector('.sbc-share-sheet__options').hidden = false;
      input.hidden = false;
      sheet.querySelector('.sbc-share-sheet__label').hidden = false;
      nativeShare(data);
    });
    sheet.querySelector('[data-share-close]').addEventListener('click', () => sheet.close());
    sheet.addEventListener('click', event => {
      if (event.target !== sheet) return;
      const box = sheet.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) sheet.close();
    });
    sheet.addEventListener('close', () => {
      document.documentElement.classList.remove('sbc-share-open');
      if (sourceButton?.isConnected) sourceButton.focus({ preventScroll: true });
    });
    nativeButton.addEventListener('click', () => { if (activeData) nativeShare(activeData); });
    sheet.querySelector('[data-share-copy]').addEventListener('click', async () => {
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(input.value);
        status.textContent = sheet.dataset.copied;
      } catch {
        input.focus();
        input.select();
        status.textContent = sheet.dataset.manual;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
